<router-outlet></router-outlet>
<spinner></spinner>
<p-toast position="bottom-center"></p-toast>
